import React, { createContext } from "react";

export const basic_theme = {
    font: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
    fontSize: 'big',
    // backgroundColor: "#31ad8e",
    backgroundColor: "whitesmoke",
    backgroundColorCalendar: "#FFFFFFA0",
    calendarEventsColor: "#000000",
    fontsInitial: {
        'Title': "'Pacifico', cursive",
        'My Task List': "'Rubik', sans-serif",
        'My Task': "'Rubik', sans-serif"
    }
}

const lang = 'en';
const direction = (lang === 'he')? 'rtl': 'ltr';


export const tasks_json = [
    {
        listId: 1,
        title: '👩🏻‍💻 המשימות שלי',
        tasks: [
            { id: 1, name: "ללמוד לרכב על אופניים" },
            { id: 2, name: "לבנות דחלילים" },
            { id: 3, name: "לטוס לישראל" },
        ]
    },
    {
        listId: 2,
        title: '⭐️ המטרות השבועיות שלי',
        tasks: [
            { id: 1, name: "ללמוד לרכב על אופניים" },
            { id: 2, name: "לבנות דחלילים" },
            { id: 3, name: "לטוס לישראל" },
        ]
    },
    {
        listId: 3,
        title: '🌱 המטרות החודשיות שלי',
        tasks: [
            { id: 4, name: "למכור רכב" },
            { id: 5, name: "לעשות קקי" },
            { id: 6, name: "לטוס לישראל" },
            { id: 7, name: "program" },
        ]
    },

]

export const user_settings = {
    calMinHour: 6,
    calMaxHour: 23,
    defaultTimeInterval: 15, // 15,30, 45,60
    // show_only_full_day_events_in_month: false, // TODO

    lang:'en',
    direction: 'ltr',

    // Weekend settings: 'friday' (Fri-Sat) or 'saturday' (Sat-Sun)
    weekendStart: 'saturday',

    // Year View settings
    yearView: {
        showTimedEvents: true,        // Whether to show <24h events
        timedEventDisplay: 'dots'     // 'dots' or 'titles'
    },

    // Sidebar settings
    sidebarCollapsed: false,
    sidebarCollapseMode: 'tabs'       // 'tabs' or 'hidden'
}
export const GrownupsContext = createContext(null);

  
  